<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-question</v-icon>
      <span class="ml-2 title">Editar preguntas</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="pregunta">
        <v-text-field
          v-model="pregunta.pregunta"
          label="Pregunta"
          :error-messages="errPregunta"
        ></v-text-field>
        <v-select
          v-model="pregunta.tipo"
          :items="tipos"
          item-text="text"
          item-value="value"
          label="Tipo de pregunta"
          :error-messages="errTipo"
        ></v-select>
        <v-combobox
          v-if="pregunta.tipo === 'multiple'"
          v-model="pregunta.opciones"
          :items="[]"
          multiple
          chips
          clearable
          label="Ingresa las opciones"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              @click="select"
              @click:close="remove(item)"
            >
              <strong>{{ item }}</strong>&nbsp;
            </v-chip>
          </template>
        </v-combobox>
        <v-btn
          color="primary"
          @click="insertPregunta()"
        >
          <v-icon left>fas fa-plus</v-icon>
          Agregar pregunta
        </v-btn>
      </v-form>
      <p class="title my-2">Preguntas</p>
      <v-alert
        v-if="!preguntas.length"
        type="info"
        text
      >
        Agrega las preguntas
      </v-alert>
      <v-row
        v-else
        style="max-height: 220px; overflow-y: scroll;"
      >
        <v-col
          v-for="(item, index) in preguntas"
          :key="index"
          cols="12"
        >
          <v-card>
            <div class="d-flex justify-space-between align-center pa-2">
              <div>
                <p class="subtitle-1 font-weight-bold my-1">{{ item.pregunta }}</p>
                <p class="body-2 my-2">{{ item.tipoText }}</p>
                <div>
                  <v-chip
                    v-for="(opcion, index) in item.opcionesText"
                    :key="index"
                    class="ml-1"
                  >
                    {{ opcion }}
                  </v-chip>
                </div>
              </div>
              <v-btn
                color="error"
                text
                icon
                @click="deletePregunta(item.id)"
              >
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    encuestaID: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      preguntas: [],
      pregunta: {
        pregunta: '',
        tipo: '',
        opciones: ''
      },
      opciones: [],
      tipos: [
        { text: 'Verdadero o falso', value: 'vf' },
        { text: 'Texto', value: 'texto' },
        { text: 'Opción multiple', value: 'multiple' }
      ]
    }
  },
  computed: {
    errPregunta () {
      const errs = []
      if (!this.$v.pregunta.pregunta.$dirty) return errs
      !this.$v.pregunta.pregunta.required && errs.push('La pregunta es requerida')
      return errs
    },
    errTipo () {
      const errs = []
      if (!this.$v.pregunta.tipo.$dirty) return errs
      !this.$v.pregunta.tipo.required && errs.push('Selecciona un tipo de pregunta')
      return errs
    }
  },
  mounted () {
    this.getPreguntas()
  },
  methods: {
    async getPreguntas () {
      if (this.encuestaID) {
        const { data } = await this.$http.preguntas.get(`?encuesta=${this.encuestaID}`)
        this.preguntas = data.map(i => {
          return {
            ...i,
            tipoText: this.tipos.find(j => j.value === i.tipo).text,
            opcionesText: i.opcions.map(j => j.valor)
          }
        })
      }
    },
    async insertPregunta () {
      this.$v.pregunta.$touch()
      if (!this.$v.pregunta.$invalid && this.validateMultiple()) {
        const pregunta = {
          pregunta: this.pregunta.pregunta,
          tipo: this.pregunta.tipo,
          encuesta: this.encuestaID
        }
        const { data } = await this.$http.preguntas.post('', pregunta)
        if (pregunta.tipo === 'multiple') {
          await this.insertOpciones(this.pregunta.opciones, data.id)
        }
        this.pregunta = {
          pregunta: '',
          tipo: '',
          opciones: []
        }
        this.$v.pregunta.$reset()
        this.getPreguntas()
      }
    },
    async insertOpciones (opciones = [], preguntaID) {
      for (const item of opciones) {
        const opcion = {
          valor: item,
          pregunta: preguntaID
        }
        await this.$http.opciones.post('', opcion)
      }
    },
    async deletePregunta (id) {
      if ((this.preguntas.length - 1) > 0 &&
        window.confirm('¿Estas seguro de borrar el registro?')) {
        await this.$http.preguntas.delete(`/${id}`)
        this.getPreguntas()
      }
    },
    validateMultiple () {
      if (this.pregunta.tipo === 'multiple' &&
        this.pregunta.opciones.length < 2) {
        window.alert('Agrega las opciones la pregunta')
        return false
      }
      return true
    }
  },
  validations: {
    pregunta: {
      pregunta: { required },
      tipo: { required }
    }
  },
  watch: {
    encuestaID () {
      this.getPreguntas()
    }
  }
}
</script>
